import { step1 } from './step-1';
import { step2 } from './step-2';

export const statisticsCampaignsSteps = [step1, step2];
